// @flow
import * as React from 'react';
import Glyph from '../core/Glyph.react';

import './PublicationDefensePrize.css';

type Props = {
  dp: ?boolean,
}

const PublicationDefensePrize = (props: Props): React.Node => {
  const dp = props.dp;
  if (dp !== true) {
    return null;
  }

  return (
    <div className="PublicationDefensePrize">
      <div className="PublicationDefensePrizeRecognition" >
          <Glyph glyph="trophy" />
      </div>
      <div className="PublicationDefensePrizeText" >
        Internet Defense Prize Runner-Up
      </div>
    </div>
  );
}

export default PublicationDefensePrize
